'use client';

/**
 * Site Navigation Component
 *
 * Navigation links matching the original Edem AI design.
 */
import { useState } from 'react';

import Link from 'next/link';

import { Menu, Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@kit/ui/dropdown-menu';
import { NavigationMenu, NavigationMenuList } from '@kit/ui/navigation-menu';

import { SiteNavigationItem } from './site-navigation-item';

const linkPaths = [
  { key: 'home', path: '/' },
  { key: 'catalog', path: '/catalog' },
  { key: 'generateMedia', path: '/generate' },
  { key: 'buildGirlfriend', path: '/create' },
  { key: 'pricing', path: '/pricing' },
] as const;

export function SiteNavigation() {
  const { t } = useTranslation('common');
  const [searchQuery, setSearchQuery] = useState('');

  const NavItems = linkPaths.map((item) => (
    <SiteNavigationItem key={item.path} path={item.path}>
      {t(`nav.${item.key}`)}
    </SiteNavigationItem>
  ));

  return (
    <>
      {/* Desktop Nav */}
      <div className={'hidden items-center justify-center gap-1 md:flex'}>
        {/* Search */}
        <div className="relative mr-4">
          <Search className="absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder={t('navbar.searchPlaceholder')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="focus:border-eros-pink/50 w-40 rounded-xl border border-white/10 bg-transparent py-2 pr-3 pl-10 text-sm text-white placeholder-gray-500 transition-all focus:outline-none lg:w-48"
          />
        </div>

        <NavigationMenu>
          <NavigationMenuList className={'gap-x-0.5 lg:gap-x-1'}>
            {NavItems}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      {/* Mobile Nav */}
      <div className={'flex justify-start sm:items-center md:hidden'}>
        <MobileDropdown />
      </div>
    </>
  );
}

function MobileDropdown() {
  const { t } = useTranslation('common');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger aria-label={t('navbar.openMenuAria')}>
        <Menu className={'h-8 w-8 text-white'} />
      </DropdownMenuTrigger>

      <DropdownMenuContent className={'w-full border-white/10 bg-[#111111]'}>
        {linkPaths.map((item) => {
          const className =
            'flex w-full h-full items-center text-white hover:text-eros-pink';

          return (
            <DropdownMenuItem key={item.path} asChild>
              <Link className={className} href={item.path}>
                {t(`nav.${item.key}`)}
              </Link>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
